module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-day",
    class: {
      'calendar-day-today': _vm.day.isToday, 'calendar-day-current-month': _vm.day.isCurrentMonth, 'calendar-day-weekend': _vm.day.isWeekend, 'calendar-day-selected': _vm.isDaySelected
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "calendar-day-number"
  }, [_vm._v(_vm._s(_vm.day.date.format('D')))])])]), _vm._v(" "), _c('div', _vm._l((_vm.missionsForDay), function(mission) {
    return _c('calendar-mission', {
      key: mission.uid,
      attrs: {
        "mission": mission
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f208f6a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarDay.vue
// module id = 579
// module chunks = 0